import { render, staticRenderFns } from "./ModalExchangeNpay.vue?vue&type=template&id=4b19cdd4&scoped=true&"
import script from "./ModalExchangeNpay.vue?vue&type=script&lang=js&"
export * from "./ModalExchangeNpay.vue?vue&type=script&lang=js&"
import style0 from "./ModalExchangeNpay.vue?vue&type=style&index=0&id=4b19cdd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19cdd4",
  null
  
)

export default component.exports